import { HTTP, HTTP_CONFIG } from '../../common/http';

import {
  CLEAR_VEHICLES,
  CREATE_CUSTOMER,
  CREATE_EXTRA,
  CREATE_QUOTE,
  CLEAR_QUOTE,
  CREATE_VEHICLE,
  DELETE_EXTRA,
  DELETE_VEHICLE,
  FETCH_CURRENCIES,
  FETCH_DONATIONS,
  FETCH_EXTRAS,
  FETCH_LOCATIONS,
  FETCH_QUOTE,
  FETCH_TOTALS,
  FETCH_VEHICLE_INSURANCE_OPTIONS,
  FETCH_VEHICLES,
  SET_CURRENCY,
  SET_CUSTOMER_STATE,
  SET_DROPOFF_DATE,
  SET_DROPOFF_LOCATION,
  SET_DROPOFF_TIME,
  SET_PICKUP_DATE,
  SET_PICKUP_LOCATION,
  SET_PICKUP_TIME,
  UPDATE_CUSTOMER,
  UPDATE_DONATION,
  UPDATE_EXTRA,
  UPDATE_VEHICLE,
  CREATE_BOOKING,
  TOGGLE_PREMIUM_VEHICLE_UPGRADE,
  SET_SELECTED_VEHICLE_TYPE
} from './mutation-types';

const localDomain = window.greenmotion ? (window.greenmotion.portalEndpoint || '') : '';
export function fetchLocations({ commit }) {
  return HTTP.get(`locations?include=country`)
    .then((response) => commit(FETCH_LOCATIONS, response.data.data));
};

export function fetchCurrencies({ commit, state }) {
  return HTTP.get(`currencies`)
    .then(response => commit(FETCH_CURRENCIES, response.data.data));
};

export function fetchQuote({ commit, state }, quoteId) {
  return HTTP.get(`quotes/${quoteId}`, {
    params: {
      include: 'selected_vehicle.vehicle,selected_vehicle.product,selected_vehicle.vehicle.product,selected_vehicle.vehicle.products,selected_vehicle.selected_insurance_options.insurance_option,selected_extras.extra,totals,user.loyalty_level,user.cards,customer,signed_routes'
    }
  }).then((response) => commit(CREATE_QUOTE, response.data.data));
};

export function clearQuote({ commit }) {
  commit(CLEAR_QUOTE);
};

export function fetchQuoteWithAdditionalIncludes({ commit, state }, { quoteId, additionalIncludes }) {
  return HTTP.get(`quotes/${quoteId}`, {
    params: {
      include: `selected_vehicle.vehicle,selected_vehicle,selected_vehicle.vehicle.product,selected_vehicle.product,selected_vehicle.vehicle.products,selected_vehicle.selected_insurance_options.insurance_option,selected_extras.extra,totals,user.loyalty_level,user.cards,customer,${additionalIncludes}`
    }
  }).then((response) => commit(CREATE_QUOTE, response.data.data));
};

export function fetchVehicles({ commit, state }, { quoteId, sortDriveAndGo }) {
  return HTTP.get(`quotes/${quoteId}/vehicles?include=products${sortDriveAndGo}`)
    .then(response => commit(FETCH_VEHICLES, response.data.data));
};

export function clearVehicles({ commit }) {
  commit(CLEAR_VEHICLES);
};

export function fetchVehicleInsuranceOptions({ commit, state }, payload) {
  return HTTP.get(`quotes/${payload.quoteId}/vehicles/${payload.vehicleId}/insurance-options`)
    .then(response => commit(FETCH_VEHICLE_INSURANCE_OPTIONS, response.data.data));
};

export function fetchExtras({ commit, state }, quoteId) {
  return HTTP.get(`quotes/${quoteId}/extras?include=profileCountries`)
    .then(response => commit(FETCH_EXTRAS, response.data.data));
};

export function createQuote({ commit }, quote) {
  commit(CREATE_QUOTE, quote);
};

export function createQuoteCustomer({ dispatch, state }, payload) {
  return HTTP.post(`quotes/${state.quote.id}/customers`, payload)
    .then(response => dispatch('fetchQuote', state.quote.id));
};

export function updateQuoteCustomer({ dispatch, state }, { payload, id }) {
  return HTTP.patch(`quotes/${state.quote.id}/customers/${id}`, payload)
    .then(response => dispatch('fetchQuote', state.quote.id));
};

export function createVehicle({ dispatch, state }, { selectedVehicle, productId }) {
  return HTTP.post(`quotes/${state.quote.id}/selected-vehicles`, { id: selectedVehicle.id, quote_vehicle_product_id: productId })
    .then(response => dispatch('fetchQuoteWithAdditionalIncludes', {
      quoteId: state.quote.id,
      additionalIncludes: 'selected_vehicle.basic_vehicle,selected_vehicle.premium_vehicle',
    }));
};

export function deleteVehicle({ commit, dispatch, state }) {
  return new Promise((resolve, reject) => {
    return HTTP.delete(`quotes/${state.quote.id}/selected-vehicles/${state.quote.selected_vehicle.data.id}`)
      .then(response => {
        commit(DELETE_VEHICLE);
        resolve();
      });
  });
};

export function updateVehicle({ dispatch, state }, { selectedVehicle, productId }) {
  if (state.quote.selected_vehicle && state.quote.selected_vehicle.data.id) {
    dispatch('deleteVehicle')
      .then(() => dispatch('createVehicle', { selectedVehicle, productId }));
  } else {
    dispatch('createVehicle', { selectedVehicle, productId });
  }
};

export function createExtra({ dispatch, state }, payload) {
  //TODO: How to handle multiple items?
  const choice = payload.extra.choices_type == 'boolean' ? true : 1;

  return HTTP.post(`quotes/${state.quote.id}/selected-extras`, { id: payload.extra.id, choice: choice, prepay: payload.prepay })
    .then(response => dispatch('fetchQuote', state.quote.id));
};

export function createVehicleInsuranceOption({ dispatch, state }, payload) {
  return HTTP.post(`quotes/${state.quote.id}/selected-vehicles/${state.quote.selected_vehicle.data.id}/selected-insurance-options`, {
    id: payload.insuranceOption.id,
    prepay: payload.prepay
  }).then(response => dispatch('fetchQuote', state.quote.id));
};

export function deleteVehicleInsuranceOption({ dispatch, state }, selectedInsuranceOption) {
  return HTTP.delete(`quotes/${state.quote.id}/selected-vehicles/${state.quote.selected_vehicle.data.id}/selected-insurance-options/${selectedInsuranceOption.id}`)
    .then(response => dispatch('fetchQuote', state.quote.id));
};

export function updateVehicleInsuranceOption({ dispatch, state }, payload) {
  return HTTP.patch(`quotes/${state.quote.id}/selected-vehicles/${state.quote.selected_vehicle.data.id}/selected-insurance-options/${payload.selectedInsuranceOption.id}`, {
    prepay: payload.prepay,
  }).then(response => dispatch('fetchQuote', state.quote.id));
};

export function deleteExtra({ dispatch, state }, selectedExtra) {
  const selectedExtraIdObjects = state.quote.selected_extras.data.filter(extra => {
    return extra.extra.data.id == selectedExtra.id;
  });
  const selectedExtraIdObject = selectedExtraIdObjects[0];

  return HTTP.delete(`quotes/${state.quote.id}/selected-extras/${selectedExtraIdObject.id}`)
    .then(response => dispatch('fetchQuote', state.quote.id));
};

export function updateExtra({ dispatch, state }, payload) {
  // TODO: Consider pattern(s) for throttling/blocking?
  let selectedExtraIdObjects = [];

  if (state.quote.selected_extras) {
    selectedExtraIdObjects = state.quote.selected_extras.data.filter(extra => {
      return extra.extra.data.id == payload.extra.id;
    });
  }

  if (selectedExtraIdObjects.length) {
    if (payload.choice == 0) {
      dispatch('deleteExtra', payload.extra);
    } else {
      const selectedExtraIdObject = selectedExtraIdObjects[0];

      return HTTP.patch(`quotes/${state.quote.id}/selected-extras/${selectedExtraIdObject.id}`, {
        choice: payload.choice,
        prepay: payload.prepay,
      }).then(response => dispatch('fetchQuote', state.quote.id));
    }
  } else {
    dispatch('createExtra', { extra: payload.extra, prepay: payload.prepay });
  }
};

export function updateQuote({ dispatch, state }, payload) {
  return HTTP.patch(`quotes/${state.quote.id}`, payload)
    .then(response => {
      dispatch('fetchQuote', state.quote.id);
      dispatch("fetchVehicles", {
        quoteId: state.quote.id,
        sortDriveAndGo: "&sort_drive_and_go",
      })
      dispatch('fetchExtras', state.quote.id);
    });
};

export function fetchTotals({ commit }, quoteId) {
  return HTTP.get(`quotes/${quoteId}/totals`)
    .then(response => commit(FETCH_TOTALS, response.data.data));
};

export function fetchDonations({ commit }, sourceId) {
  return HTTP.get(`sources/${sourceId}/donation-types`)
    .then(response => commit(FETCH_DONATIONS, response.data.data));
};

export function setCustomerState({ commit }, payload) {
  commit(SET_CUSTOMER_STATE, payload);
};

export function setCurrencyState({ commit, dispatch, state }, currency) {
  new Promise((resolve, reject) => {
    if (currency) {
      localStorage.setItem('currency', currency.code);
      resolve(currency.code);
    } else {
      resolve();
    }
  }).then(() => {
    if (currency) {
      commit(SET_CURRENCY, currency);
    }
    if (window.bus) {
      window.bus.$emit('fetch-vehicles-on-currency-change')
    }
  });
};

export function setDefaultCurrency({ commit, dispatch, state }) {
  new Promise((resolve, reject) => {
    resolve(localStorage.getItem('currency'));
  }).then((storedCurrency) => {
    storedCurrency = storedCurrency || window.greenmotion.defaultCurrency;

    const selectedCurrency = state.currencies.filter(currency => {
      return currency.code == storedCurrency;
    });

    if (selectedCurrency) {
      dispatch('setCurrencyState', selectedCurrency[0]);
    }
  });
};

export function setPickupDate({ commit }, date) {
  commit(SET_PICKUP_DATE, date);
};

export function setPickupTime({ commit }, time) {
  commit(SET_PICKUP_TIME, time);
};

export function setDropoffDate({ commit }, date) {
  commit(SET_DROPOFF_DATE, date);
};

export function setDropoffTime({ commit }, time) {
  commit(SET_DROPOFF_TIME, time);
};

export function setPickupLocation({ commit }, location) {
  commit(SET_PICKUP_LOCATION, location);
};

export function setDropoffLocation({ commit }, location) {
  commit(SET_DROPOFF_LOCATION, location);
};

export function linkQuoteUser({ commit }, { userId, quoteId }) {
  return HTTP.post(`${localDomain}quotes/${quoteId}/link`, {
    user_id: userId
  });
};

export function createBooking({ commit }, payload) {
  return HTTP.post('bookings', payload);
};

export function togglePremiumVehicleUpgrade({ commit, dispatch, state }) {
  const selectedVehicle = state.hasUpgradedVehicle ? state.quote.selected_vehicle.data.basic_vehicle.data : state.quote.selected_vehicle.data.premium_vehicle.data;
  dispatch('updateVehicle', { selectedVehicle });
  commit(TOGGLE_PREMIUM_VEHICLE_UPGRADE);
};

export function setSelectedVehicleType({ commit }, type) {
  commit(SET_SELECTED_VEHICLE_TYPE, type);
}


// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/vuex/quotes/actions.js